export default __webpack_public_path__ + "static/media/bg1.7c06aac4.jpg";